export default "__VITE_ASSET__D_A8T7tf__"